/**
 * Scan results are ingested by the backend from the Agent result topic.
 * This mount stays in the tree so the app structure is unchanged, and it
 * does not open a broker session. DevicesPage polls the discovery task
 * the backend finalizes.
 */
const ScanResultProcessorMount = () => null;

export default ScanResultProcessorMount;
